import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetProcessModelsQuery } from "../../../hooks/useGetProcessModelsQuery";
import { setProcessModelData } from "../../../redux/slices/finance/processModel";
import { routes } from "../../../routes";
import { updateProcessModel } from "../../../services/finance/processModels";
import { ProcessModelType } from "../../../types/Finance";
import { Key_processModels } from "../../../utils/constants";

const columnNamesMap: { [key: string]: string } = {
    processName: 'Nome do Processo',
    description: 'Descrição',
};

export const ProcessModels = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<ProcessModelType | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetProcessModelsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateProcessModel, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_processModels);
            toast.success('Apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handleClickCreate = () => {
        navigate(routes.createProcessModel);
    };

    const handleEdit = (p: ProcessModelType) => {
        dispatch(setProcessModelData(p));
        navigate(routes.updateProcessModel);
    };

    const handleDelete = async (p: ProcessModelType) => {
        p.status = false;
        await mutationUpdate.mutateAsync(p);
    };

    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem);
        }
    };

    const openDeleteDialog = (p: ProcessModelType) => {
        setDeleteItem(p);
    };

    const options = data?.items.map((p: ProcessModelType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(p),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(p),
            icon: <TrashIcon />
        },
    ]) || [];

    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                description="O modelo de processo será eliminado."
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}